import CreatePromotion from './CreatePromotion.container';

export default CreatePromotion;
